<form #newModule="ngForm" (ngSubmit)="createupdatemodule()" class="course-form mb-0">

  <!-- Page header -->
  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-graduation-cap" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">{{moduleid ? 'Edit Course' : 'Create New Course'}}</h1>
      <p class="cf-head__sub">Add course details and configure settings</p>
    </div>
    <div class="cf-head__actions">
      <button class="btn btn--warning m-0" type="button" *ngIf="!moduleid && schoolid" routerLink="/user/schoolhome">Cancel</button>
      <button class="btn btn--warning m-0" type="button" *ngIf="moduleid" routerLink="/user/moduledetails"
        [queryParams]="{moduleID: module.id}">Cancel</button>
      <button class="btn m-0" [disabled]="!newModule.form.valid" type="submit">
        <i class="fas fa-save" aria-hidden="true"></i> Save Course
      </button>
    </div>
  </header>

  <!-- Header image -->
  <section class="cf-card">
    <div class="cf-card__split">
      <div>
        <h2 class="cf-card__title">Header Image
          <span class="position-relative d-inline-flex align-items-center">
            <button type="button" data-toggle="dropdown" aria-expanded="false" title="Header image"
              class="d-flex align-items-center px-2 bg-transparent border-0 text-body"><i
                class="fa fa-info-circle"></i></button>
            <span class="info-popup dropdown-menu p-2">
              <span class="form-info-p">The banner shown at the top of the course page and on the course card.
                Optional.</span>
            </span>
          </span>
        </h2>
        <p class="cf-card__hint">Add a header image to make your course stand out</p>
      </div>
      <div class="cf-image">
        <div *ngIf="logoimg.style.display === 'none'" class="cf-image__empty">
          <i class="far fa-image" aria-hidden="true"></i>
          <span>No image added</span>
          <small>Recommended {{settings.moduleImageWidth}} x {{settings.moduleImageHeight}}px</small>
        </div>
        <img #logoimg src="{{module.logo}}" alt="Course header image" class="cf-image__preview" style="display: none;" (error)="logoimg.style.display = 'none'">
        <button (click)="logo.click()" type="button" id="courseHeaderImgLabel" class="btn m-0 mt-2">
          <i class="fa fa-plus"></i> Add Header Image
        </button>
        <input #logo (change)="handleLogoFileChange($event.target.files)" type="file" name="logo" accept="image/*"
          aria-labelledby="courseHeaderImgLabel" id="courseHeaderImg" class="sr-only">
      </div>
    </div>
  </section>

  <!-- Basic information -->
  <section class="cf-card">
    <h2 class="cf-card__title"><i class="far fa-file-alt" aria-hidden="true"></i> Basic Information</h2>

    <div class="cf-grid">
      <div class="fieldset fieldset--lg">
        <label class="legend" for="schoolname">Course Name <span class="requiredfield">*</span></label>
        <input type="text" [(ngModel)]="module.name" #name name="name" maxlength="200" required class="text-field"
          id="schoolname">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Course name"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">The name students see on the course page and in their course list. Up to
            200 characters.</p>
        </div>
      </div>
      <div class="fieldset fieldset--lg">
        <label class="legend" for="code">Course Code</label>
        <input type="text" [(ngModel)]="module.courseCode" #courseCode name="courseCode" class="text-field" id="code">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Course code"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">A short reference for the course, such as BIO101. Optional.</p>
        </div>
      </div>
    </div>

    <div class="cf-description">
      <div class="fieldset fieldset--note">
        <label class="legend z-1">Course Description <span class="requiredfield">*</span></label>
        <!-- Bound with ngModel so `required` actually applies. It previously carried a bare
             `required` attribute, which does nothing on a custom component — a course could
             be saved with no description at all despite the asterisk. -->
        <quill-editor #description name="description" required [(ngModel)]="module.description"
          placeholder="Describe what this course is about..."></quill-editor>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Course description"
          class="position-absolute right-0 top-0 mt-2 d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Shown on the course page before a student enrolls, so it is what they read when
            deciding whether to take the course. Required.</p>
        </div>
      </div>
      <aside class="cf-tips">
        <h3><i class="far fa-lightbulb" aria-hidden="true"></i> Tips for a great description</h3>
        <ul>
          <li>Explain what students will learn</li>
          <li>Highlight key benefits</li>
          <li>Keep it clear and engaging</li>
          <li>Use short paragraphs</li>
        </ul>
      </aside>
    </div>
  </section>

  <!-- Course settings -->
  <section class="cf-card">
    <h2 class="cf-card__title"><i class="fas fa-cog" aria-hidden="true"></i> Course Settings</h2>

    <div class="cf-grid cf-grid--three">
      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="allowBatches">Batch Students</label>
        <select class="text-field" [(ngModel)]="module.allowBatches" #allowBatches name="allowBatches" id="allowBatches">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="About batches"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Teach your course in batches to make sure all your students start and end the course together.
            Extremely useful when you intend to teach your students in live classes</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <!-- id was "accessDays" — a duplicate of the field below — and this also flagged an
             access-days change, so editing the pass mark rewrote every existing student's
             access period. -->
        <label class="legend" for="passScore">Pass Score (%)</label>
        <input type="number" [(ngModel)]="module.passScorePercentage" #passScorePercentage name="passScorePercentage"
          min="0" max="100" class="text-field" id="passScore">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Pass score"
          class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">The course score a student needs to pass. The course score is a weighted average of the
            student's % on each assessment that is not optional, using each assessment's Weight. Leave it at 0 if the
            course has no pass mark. A student who has not submitted every one
            of those assessments does not pass whatever their score, and a student who does not pass is not
            marked as having completed the course and gets no certificate.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend" for="price">Price</label>
        <input type="number" [(ngModel)]="module.price" #price name="price" min="0" class="text-field" id="price">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Price"
          class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">What a student pays to enroll, in your school's currency. Leave it empty or 0 for a free course.
            Charging for a course needs the e-commerce feature on your plan, and a course with a price always
            requires enrollment.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend" for="accessDays">Access Days</label>
        <input type="number" [(ngModel)]="module.accessdays" #accessdays name="accessdays" min="0" class="text-field"
          id="accessDays" (change)="this.accessDaysChanged = true;">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Access days"
          class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">How many days a student keeps access after enrolling. 0 means access never expires. Once the days
            run out the lessons close and the course drops off their course list, but their completed lessons
            are kept if they enroll again. Changing this asks whether to apply the new number to students
            already enrolled, counted from the date each of them enrolled.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="reqEnroll">Require Enrollment</label>
        <select class="text-field" [(ngModel)]="module.requireEnrollment" #requireEnrollment name="requireEnrollment"
          id="reqEnroll" [disabled]="module.price">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Require enrollment"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Yes means only enrolled students can open the lessons. No lets any signed-in student of your
            school read the course without enrolling, which works only on a free course and only while your
            school allows students to enroll themselves. A course with a price is always set to Yes.</p>
        </div>
        <small class="cf-note" *ngIf="module.price">Always required for a paid course</small>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="retakemultiplechoice">Allow Retake for Multiple Choice Assessment</label>
        <select class="text-field" [(ngModel)]="module.retakemultiplechoice" #retakemultiplechoice
          name="retakemultiplechoice" id="retakemultiplechoice">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false" selected>No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Retaking multiple choice"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Lets a student clear a submitted multiple choice assessment and sit it again. It applies only to
            assessments whose type is multiple choice. Essay, short answer and file upload assessments are not
            affected, and a retake on those still has to be granted by a tutor on the individual submission.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="userCompleteCourseWhenAllLessonsAreCompleted">Complete When All Lessons Done</label>
        <select class="text-field" [(ngModel)]="module.userCompleteCourseWhenAllLessonsAreCompleted"
          #userCompleteCourseWhenAllLessonsAreCompleted name="userCompleteCourseWhenAllLessonsAreCompleted"
          id="userCompleteCourseWhenAllLessonsAreCompleted">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Completing the course"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Gives students a button to finish the course once every lesson is done. The course is only marked
            complete if they have also reached the pass score, and that is what sends the completion email and
            the certificate. With No the course is never marked complete.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="sendMarkedNotification">Send Notification on Grade</label>
        <select class="text-field" [(ngModel)]="module.sendMarkedNotification" #sendMarkedNotification
          name="sendMarkedNotification" id="sendMarkedNotification">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Grade notifications"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Emails the student a link to their result when an assessment of theirs is graded. Multiple choice
            assessments are graded the moment they are submitted, so the email goes out then. Essay, short
            answer and file upload assessments send it when a tutor saves the marks.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="sendMilestoneNotification">Activate Lesson Deadline</label>
        <select class="text-field" [(ngModel)]="module.activateLessonDeadlineNotification" #sendMilestoneNotification
          name="sendMilestoneNotification" id="sendMilestoneNotification">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false" selected>No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="About lesson deadlines"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Gives each lesson a due date and emails students a reminder as it approaches.
            The due date is worked out from the deadline you set on the lesson itself, counted from the day
            the student enrolled or from the lesson's publish date if it uses a fixed deadline. Students
            see the dates on their progress timeline, and anything overdue is marked. Lessons with no
            deadline set are unaffected.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="reqCompletion">Require Lesson Completion in Order</label>
        <select class="text-field" [(ngModel)]="module.requireLessonCompletion" #requireLessonCompletion
          name="requireLessonCompletion" id="reqCompletion">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Lesson order"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Students have to finish each lesson before the next one opens. With No they can take the lessons
            in any order. Tutors and course admins are not affected either way.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="sendCertificateOnCompletion">Generate Certificate On Completion</label>
        <select class="text-field" [(ngModel)]="module.sendCertificateOnCompletion" #sendCertificateOnCompletion
          name="sendCertificateOnCompletion" id="sendCertificateOnCompletion">
          <option [ngValue]="true" selected>Yes</option>
          <option [ngValue]="false">No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Certificates"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Emails the student a PDF certificate in their name when they complete the course and reach the
            pass score, using the certificate template your school has in use. It needs 'Complete When All
            Lessons Done' set to Yes, since that is what marks a course complete.</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend" for="publishDate">Publish Date</label>
        <input [owlDateTime]="rawpublisheddatetime" class="text-field" id="publishDate" name="publishDate"
          #publishDate [(ngModel)]="module.publishDate">
        <button type="button" [owlDateTimeTrigger]="rawpublisheddatetime"
          class="owlDateTimeTrigger position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
          title="Calendar"><i class="fa fa-calendar"></i></button>
        <owl-date-time #rawpublisheddatetime></owl-date-time>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Date of availability"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">This is the date from which the course will be made available</p>
        </div>
      </div>

      <div class="fieldset fieldset--lg">
        <label class="legend z-1" for="virtualInstructor">Virtual Instructor-Led</label>
        <select class="text-field" [(ngModel)]="module.virtualInstructor" #virtualInstructor name="virtualInstructor"
          id="virtualInstructor">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false" selected>No</option>
        </select>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Virtual instructor-led"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Marks the course as taught live by an instructor. It adds a Virtual Instructor-Led label to the
            course and shows the meeting schedule and start date below on the course card and calendar. It
            does not create the meetings themselves.</p>
        </div>
      </div>

      <div *ngIf="module.virtualInstructor" class="fieldset fieldset--lg">
        <label class="legend" for="virtualschedule">Virtual Meeting Time Schedule</label>
        <input type="text" [(ngModel)]="module.virtualSchedule" #virtualschedule name="virtualschedule" maxlength="200"
          class="text-field" id="virtualschedule">
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Meeting schedule"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">Recurring schedule for virtual meetings (e.g., Mondays, 6:00 PM - 7:30 PM GMT).</p>
        </div>
      </div>

      <div *ngIf="module.virtualInstructor" class="fieldset fieldset--lg">
        <label class="legend z-1" for="startDate">Start Date</label>
        <input [owlDateTime]="startdate" class="text-field" id="startDate" name="startDate" #startDate
          [(ngModel)]="module.startDate">
        <button type="button" [owlDateTimeTrigger]="startdate"
          class="owlDateTimeTrigger position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
          title="Calendar"><i class="fa fa-calendar"></i></button>
        <owl-date-time #startdate></owl-date-time>
        <button type="button" data-toggle="dropdown" aria-expanded="false" title="Start Date"
          class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
            class="fa fa-info-circle"></i></button>
        <div class="info-popup dropdown-menu p-2">
          <p class="form-info-p">This is the date the course starts, will be displayed in course calendar</p>
        </div>
      </div>
    </div>

    <!-- How Pass Score and each assessment's Weight combine; live example -->
    <app-scoring-explainer class="d-block mt-4" context="course" [moduleId]="moduleid" [passScore]="module.passScorePercentage"></app-scoring-explainer>
  </section>

  <!-- Footer -->
  <div class="cf-footer">
    <span class="cf-footer__hint">
      <i class="fas fa-graduation-cap" aria-hidden="true"></i>
      <span>
        <strong>After saving, you'll be able to add lessons, quizzes and more.</strong><br>
        You can always edit some of these settings later.
      </span>
    </span>
    <span class="cf-footer__actions">
      <button class="btn btn--warning m-0" type="button" *ngIf="!moduleid && schoolid" routerLink="/user/schoolhome">Cancel</button>
      <button class="btn btn--warning m-0" type="button" *ngIf="moduleid" routerLink="/user/moduledetails"
        [queryParams]="{moduleID: module.id}">Cancel</button>
      <button class="btn m-0" [disabled]="!newModule.form.valid" type="submit">Save &amp; Continue</button>
    </span>
  </div>
</form>

<div *ngIf="this.moduleid" class="modal fade" #mediaModal tabindex="-1" role="dialog" aria-labelledby="mediaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="mediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-module-media-library [moduleid]="this.moduleid" [enableselect]="true"
          (mediaSelected)="mediaSelected($event)"></app-module-media-library>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn--warning" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" #externalMediaModal tabindex="-1" role="dialog" aria-labelledby="externalMediaModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="externalMediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-external-media #addExternalMediaComponent></app-add-external-media>
      </div>      
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" (click)="externalMediaSelected()"
          [disabled]="!addExternalMediaComponent.iframeurl">Ok</button>
        <button type="button" class="btn btn--warning m-0" (click)="closeExternalMediaModal()">Close</button>
      </div>
    </div>
  </div>
</div>
